import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=3a919fd9&scoped=true"
import script from "./Price.vue?vue&type=script&setup=true&lang=ts"
export * from "./Price.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Price.vue?vue&type=style&index=0&id=3a919fd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a919fd9",
  null
  
)

export default component.exports